import { ActionType } from '@editor/src/js/constants/common-action-type';
import { WorkbenchMobileContextMenuSchema } from '@tencent/workbench';

export const COMMON_MOBILE_CONTEXT_MENU: WorkbenchMobileContextMenuSchema = [
    ActionType.MOVE_SLIDE_UP,
    ActionType.MOVE_SLIDE_DOWN,
    ActionType.MOBILE_SELECT_ALL,
    ActionType.MOBILE_EDIT,
    ActionType.CUT,
    ActionType.COPY,
    ActionType.PASTE,
];
